export const PROD_CENTRAL_AUTH_PROTOCOL = 'https:';

function isLocalHostname(hostname: string) {
  return ['127.0.0.1', 'localhost'].includes(hostname);
}

export function buildCentralAuthRedirectTarget(input: {
  currentHref: string;
  returnTo?: string;
}) {
  const currentUrl = new URL(input.currentHref);
  const targetUrl = input.returnTo
    ? new URL(input.returnTo, currentUrl.origin)
    : currentUrl;

  if (!isLocalHostname(targetUrl.hostname)) {
    targetUrl.protocol = PROD_CENTRAL_AUTH_PROTOCOL;
  }

  return targetUrl.href;
}

export function isLocalDevHost(hostname: string) {
  return isLocalHostname(hostname);
}
